<template>
    <v-container>
        <h3 class="mb-5">ดาวน์โหลดข้อเสนอแนะการประเมินหัวหน้าส่วนงาน</h3>

        <v-card elevation="2" :loading="loading" :disabled="loading">
            <v-card-title>เงื่อนไขการดาวน์โหลด</v-card-title>
            <v-card-text>
                <v-form v-model="valid">
                    <v-row>
                        <v-col cols="12">
                            <v-select label="เลือกผู้รับการประเมิน" :items="assessees" item-text="fullName"
                                item-value="crossGroup" dense outlined v-model="crossGroup" :return-object="false"
                                :rules="requiredRule"></v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!valid" @click="download">Download</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import server from '../../../../services/server';
import ui from '../../../../services/ui';

export default {
    name: "AssessmentReportExport",

    data() {
        return {
            assessees: [],
            loading: false,
            valid: false,
            requiredRule: [ui.requiredRule],
            crossGroup: null,
        }
    },

    async mounted() {
        this.loading = true
        this.assessees = await server.get('report2023/assessee_cross_group')
        this.loading = false
    },

    methods: {
        async download() {
            const url = process.env.VUE_APP_SERVER + 'api/report2023/comment/' + this.crossGroup
            window.open(url)
        },
    }
}
</script>
